/**
 * Which film leads the person's page: the introduction or Today's minute
 * (Nov 1, rev 2). No question to answer and no pop-up — the poster decides:
 *
 *   - Until she has watched the introduction through: the introduction, and
 *     no choice shown.
 *   - The day she finishes it: still the introduction, with "Today's minute"
 *     now a tab on the poster (a small dot says there's one she hasn't seen).
 *   - From the next day on: Today's minute leads, with "Introduction" one tap
 *     away on the same poster.
 *   - A tab she taps holds for the rest of that day, then the rule above
 *     takes over again.
 *
 * Kept per person in this browser (localStorage); private windows simply get
 * the rule. Days are her local calendar days.
 */
const key = clientId => `cg.poster.v1.${clientId}`;

export function localDay(d = new Date()) {
  const p = n => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function readPoster(clientId) {
  try { return JSON.parse(window.localStorage.getItem(key(clientId)) || "{}") || {}; } catch { return {}; }
}

export function writePoster(clientId, patch) {
  const next = { ...readPoster(clientId), ...patch };
  try { window.localStorage.setItem(key(clientId), JSON.stringify(next)); } catch { /* fine */ }
  return next;
}

/** "intro" or "minute". */
export function pickTab({ introDone, hasMinute, stored = {}, today }) {
  if (!introDone || !hasMinute) return "intro";
  if (stored.tabDay === today && stored.tab) return stored.tab;
  if (stored.doneDay && stored.doneDay < today) return "minute";
  return "intro";
}

/** A dot on "Today's minute" when today's hasn't been played and it isn't showing. */
export function minuteIsNew({ tab, stored = {}, today }) {
  return tab !== "minute" && stored.minuteDay !== today;
}
